import React, { useEffect, useState } from "react";
import { Offcanvas, Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";

import { DeleteForeverOutlined, DisplaySettingsOutlined, ErrorOutline } from "@mui/icons-material";

import useFooter from "../../hooks/useFooter";
import SidebarFooter from "../../components/pgi/SidebarFooter";
import FooterReplica from "./editComponents/FooterReplica";

const FooterPgi = () => {
  const { footerCats, updateFooterCat, getAllFooterCats } = useFooter();
  const [showEditFooter, setShowEditFooter] = useState(true);
  const handleClose = () => setShowEditFooter(false);
  const handleShow = () => setShowEditFooter(true);

  useEffect(() => {
    getAllFooterCats();
  }, [])

  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">¿Estas seguro de eliminar esta categoría de links?</div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id)}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000
      }
    );
  };

  const handleConfirmDelete = (id) => {
    const deletedCats = footerCats.filter((cat) => cat._id === id);
    deletedCats[0].deleted = true;

    deletedCats.forEach((cat, i) => {
      updateFooterCat(cat).then((res) => {
        toast.success("Se guardó la categoría de Footer y sus links");
        window.location.reload();
      });
    });
  };

  return (
    <div id="wrapperEditFooter" className="wrapperPgi footer-pgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi pt-3 pb-3">
        <FooterReplica />
      </div>

      {/* OFFCANVAS SETTING FOOTER*/}
      <Offcanvas
        show={showEditFooter}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR SECCIÓN FOOTER</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <header aria-labelledby="formEditarHSlider" className="d-flex justify-content-between">
            <h3>Categorías de Links del Footer</h3>
            <>
              <SidebarFooter />
            </>
          </header>
          <Table responsive className="basePgi__table-list" hover>
            <colgroup>
              <col span="1" className="basePgi__table-col-min" />
              <col span="1" className="basePgi__table-col-max" />
              <col span="2" className="basePgi__table-col-min" />
            </colgroup>
            <tbody>
              {footerCats?.map((footerCategory, index) => {
                return (
                  <>
                    <tr key={footerCategory?._id}>
                      {/* <td></td> */}
                      <td>{index + 1}</td>
                      <td>{footerCategory?.category}</td>
                      <td>
                        <SidebarFooter isEdit={true} itemsToEdit={footerCategory} />
                      </td>

                      <td onClick={() => handleDelete(footerCategory?._id)}>
                        {/* acción--> ELIMINA PUBLICACIÓN */}
                        <OverlayTrigger
                          key="1"
                          placement="top"
                          overlay={<Tooltip id="1">Eliminar</Tooltip>}
                        >
                          <Button>
                            <DeleteForeverOutlined />
                          </Button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </Table>

          {/****************end lista productos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default FooterPgi;
